import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = { class: "list" };
import AppVideoItem from '@/components/app-video-item.vue';
import { ref } from 'vue';
import axios from 'axios';
export default /*#__PURE__*/ _defineComponent({
    __name: 'home-video-list',
    setup: function (__props) {
        var list = ref([]);
        axios({
            method: 'get',
            url: '/videosList'
        }).then(function (res) {
            console.log('视频列表的数据', res.data.result);
            list.value = res.data.result;
        });
        return function (_ctx, _cache) {
            var _directive_lazy = _resolveDirective("lazy");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, function (item) {
                    return _withDirectives((_openBlock(), _createBlock(AppVideoItem, {
                        key: item.id,
                        video: item
                    }, null, 8, ["video"])), [
                        [_directive_lazy, item]
                    ]);
                }), 128))
            ]));
        };
    }
});
